define('meeting-modal/tab-options/coorganizer-tab',['require','api-access','api-access','coorganizer-search','knockout','lodash'],function (require) {
    var userApi = require('api-access').user;
    var meetingsApi = require('api-access').meetings;
    require('coorganizer-search');

    var ko = require('knockout');
    var _ = require('lodash');

    /**
     * If a meetingId is supplied, the module will assume edit behavior.
     * For schedule behavior, do not supply a meetingId.
     */
    var CoorganizerTab = function (meetingId) {
        var self = this;

        self.isCoorganizerEnabled = ko.observable();

        self.coorganizers = ko.observableArray([]);
        self.coorgQuery = ko.observable();
        self.coorgResults = ko.observableArray();

        self.isShowCoorgResults = ko.computed(function () {
            if (self.coorgQuery()) {
                return self.coorgQuery().length >= 2;
            }
            return undefined;
        });

        self.organizerKey = ko.observable();

        self.addCoorg = function (coorg) {
            self.coorganizers.push(coorg);
            self.coorgQuery('');
        };

        self.removeCoorg = function (coorg) {
            self.coorganizers.remove(coorg);
        };

        /**
         * Returns relevant data, formatted for consumption by the API.
         */
        self.buildOptions = function () {
            return {
                coorganizerKeys: _.pluck(self.coorganizers(), 'key')
            };
        };

        self.activate = function () {
            userApi.me().then(function (me) {
                self.organizerKey(me.key);
            });

            return userApi.settings().then(function (settings) {
                self.isCoorganizerEnabled(settings.isCoorganizerFeatureEnabled);

                if (meetingId && self.isCoorganizerEnabled()) {
                    meetingsApi.byIdFormatted(meetingId)
                        .then(function (meeting) {
                            if (meeting.coorganizers) {
                                self.coorganizers(meeting.coorganizers);
                            }
                        });
                }
            });
        };
    };

    return CoorganizerTab;
});

